import React from 'react'
import Transactions from '../../components/table'

const Transaction = () => {
  return (
    <Transactions/>
  )
}

export default Transaction